<template>
    <div class="Teamarchives">
        <div class="header">
            <el-row>
                <el-col :span="6">
                    <label class="headerlabel">用户信息</label>
                    <el-input v-model="param.Name" placeholder="请输入用户信息" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="6">
                    <label class="headerlabel">咨询方式</label>
                    <el-select v-model="param.ConsultType" placeholder="请选择" filterable  class="autowidth" clearable >
                        <el-option label="线下咨询"  :value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <label class="headerlabel">下单时间</label>
                    <el-date-picker    
                    class="autowidth"
                    clearable
                    v-model="Finalpaymenttime"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
                </el-col>
                <el-col :span="6">
                    <el-button type="primary" @click="init">筛选</el-button>
                    <el-button @click="reset">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <el-button type="primary" style="margin-bottom: 10px;" @click="NewdialogVisible=true">新建团体诉求</el-button>
            <el-table
            :data="GroupdemandsData"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%;margin-bottom: 20px;">
                <el-table-column prop="userID" label="用户ID"></el-table-column>
                <el-table-column prop="realName" label="用户名称"></el-table-column>
                <el-table-column prop="consultType" label="咨询方式"></el-table-column>
                <el-table-column prop="counselor" label="咨询师"></el-table-column>
                <el-table-column prop="serviceDemands" label="服务诉求"></el-table-column>
                <el-table-column prop="peopleNum" label="人数"></el-table-column>
                <el-table-column prop="servicePrice" label="订单价格"></el-table-column>
                <el-table-column prop="consultationLocation" label="咨询地点"></el-table-column>
                <el-table-column prop="phone" label="手机号码"></el-table-column>
                <el-table-column prop="state" label="订单状态">
                    <!-- <template slot-scope="scope">
                        <div v-if="scope.row.state==0">待处理</div>
                        <div v-else-if="scope.row.state==1">待咨询</div>
                        <div v-else-if="scope.row.state==2">已完成</div>
                        <div v-else>已关闭</div>
                    </template> -->
                </el-table-column>
                <el-table-column label="咨询时间">
                    <template slot-scope="scope">
                        {{ scope.row.effectiveDate?scope.row.effectiveDate:'--' }}
                    </template>
                </el-table-column>
                
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" style="margin-right: 10px;" @click="ClickEdit(scope.row)">修改</el-button>
                        <el-button v-if="scope.row.state=='待咨询' && RoleID=='1059'" type="text" style="margin-right: 10px;" @click="ClickDetial(scope.row)">跟进</el-button>
                        <el-button v-if="scope.row.state=='待跟进' && RoleID=='1059'" type="text" style="margin-right: 10px;" @click="ClickDetial(scope.row)">填写</el-button>
                        <el-button type="text" style="margin-right: 10px;" @click="ClickDetial(scope.row)">跟进</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageIndex"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

        <!-- 新建团体诉求 -->
        <el-dialog
            title="新建团体诉求"
            :visible.sync="NewdialogVisible"
            width="480px"
            center
            :before-close="NewhandleClose">
           <div class="ruleContent">
            <div class="item">
                <label>预约主题</label>
                <el-select v-model="diaParam.ConsultTheme" placeholder="请选择主题" filterable  class="autowidth" clearable >
                    <el-option v-for="item in theme" :label="item" :value="item"></el-option>
                </el-select>
            </div>
            <div class="item">
                <label>咨询师</label>
                <el-cascader 
                class="autowidth"
                v-model="diaParam.Counselor" 
                placeholder="请选择咨询师" 
                :options="dropUserAll"
                @change="getCheckedNodes"
                :props="props" 
                filterable 
                clearable>
                </el-cascader>
            </div>
            <div class="item">
                <label>咨询地点</label>
                <el-input v-model="diaParam.ConsultationLocation" placeholder="请输入咨询地点" class="autowidth" clearable maxlength="100" show-word-limit></el-input>
            </div>
            <div class="item">
                <label>人数限制</label>
                <el-select v-model="diaParam.PeopleNum" placeholder="请选择人数" filterable  class="autowidth" clearable >
                    <el-option v-for="(item,index) in People" :label="item" :value="item"></el-option>
                </el-select>
            </div>
            
            
            <div class="item">
                <label>场次价格</label>
                <el-input v-model="diaParam.ServicePrice" placeholder="请输入实际售价" class="autowidth" clearable maxlength="20" show-word-limit></el-input>
            </div>
            <div class="item">
                <label>优惠折扣</label>
                <el-input v-model="diaParam.Discount" placeholder="例如8.8折" class="autowidth" clearable maxlength="10" show-word-limit></el-input>
            </div>
            <div class="item">
                <label>咨询日期</label>
                <el-date-picker    
                    class="autowidth"
                    clearable
                    v-model="consultDate"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </div>

            <div class="item">
                <label>咨询时段</label>
                <div class="autowidth">
                    <el-time-select
                    class="courseTime"
                    placeholder="起始时间"
                    v-model="diaParam.StartTime"
                    :picker-options="{
                    start: '09:00',
                    end: '18:30'
                    }">
                    </el-time-select>
                    <el-time-select
                        class="courseTime"
                        placeholder="结束时间"
                        v-model="diaParam.EndTime"
                        :picker-options="{
                        start: '09:00',
                        end:'18:00',
                        minTime: diaParam.StartTime
                        }">
                    </el-time-select>
                </div>
            </div>

            <div class="item">
                <label>客服电话</label>
                <el-input v-model="diaParam.CustomerServicePhone" placeholder="请输入客服电话" class="autowidth" clearable></el-input>
            </div>

           </div>
            <div style="text-align: center;margin: 20px 0 10px;">
                <el-button @click="NewhandleClose">取消</el-button>
                <el-button type="primary" @click="AddSave()">{{diaParam.RequestKey==''?'保存':'修改'}}</el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="团体档案跟进"
            :visible.sync="dialogVisible"
            width="640px"
            center
            :before-close="handleClose">
           <div class="ruleContent">
            <div class="item">
                <label>服务诉求</label>
                <el-input type="textarea" v-model="paramfollow.serviceDemands" placeholder="请填写服务诉求" clearable maxlength="500" show-word-limit></el-input>
            </div>

            <div class="item">
                <label>活动内容</label>
                <el-input type="textarea" v-model="paramfollow.activeContent" placeholder="请填写活动内容" clearable maxlength="500" show-word-limit></el-input>
            </div>

            <div class="item">
                <label>活动图片</label>
                <el-upload
                    class="uploadimg"
                    :action="updataUrl"
                    :headers="{Authorization:Authorization}"
                    name="images"
                    list-type="picture-card"
                    :on-success="handleimgSuccess"
                    :on-remove="handleRemove"
                    ref="uploadimgrefss"
                    :auto-upload="true">
                        <i slot="default" class="el-icon-plus"></i>
                </el-upload>
            </div>

            <div class="item" style="display: flex;">
                <label>上传文件</label>
                <el-upload
                    class="upload-demo"
                    drag
                    :action="updataUrl"
                    :headers="{Authorization:Authorization}"
                    name="images"
                    ref="uploadfilerefss"
                    accept=".doc,.docx,.pdf"
                    :on-success="handlefileSuccess"
                    :on-remove="handlefileRemove"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传docx/doc/pdf文件格式</div>
                </el-upload>
            </div>

           </div>
            <div style="text-align: center;margin: 20px 0 10px;">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
export default{
    data() {
        return {
            updataUrl:process.env.VUE_APP_URL+'AppUser/UpdatePortraitAndCertificate',
            Authorization:sessionStorage.getItem('Authorization'),
            loading:false,
            Finalpaymenttime:[],
            param:{
                pageIndex:1,
                pageSize:10,
                PageTotal:0,
                Name: "",
                ConsultType:'',
                StartTime: "",
                EndTime: ""
            },
            paramfollow:{
                serviceDemands:'',
                activePicture: "", //活动照片
                programmePath: "", //方案文件
                activeContent: "" //活动内容
            },
            
            GroupdemandsData:[],
            activePicture:[],
            programmePath:[],
            MemeberPackageData:[],
            dialogVisible:false,
            // 上传图片
            disabled: false,

            //新建团体诉求
            NewdialogVisible:false,
            theme:['心理测评','心理咨询（访谈）','授课','团体辅导'],
            People:['2-3','3-5','5-8','8-12','12-16','16-20','20-30'],
            UserID:JSON.parse(sessionStorage.getItem('xinxi')).UserID,
            RoleID:JSON.parse(sessionStorage.getItem('xinxi')).RoleID,
            diaParam:{
                RequestKey:'',
                userID:'',  //登陆者UserID
                PeopleNum:'', //人数限制
                ServicePrice:'', // 场次价格
                ServicePrice:'', // 预约主题
                StartDate:'', //开始日期
                EndDate:'', // 结束日期
                Discount:'',// 折扣
                Counselor:'',// 咨询师
                ConsultationLocation:'',// 咨询地点
                CustomerServicePhone:'',//  客服电话
                StartTime:'',// 开始时间
                EndTime:'', //结束时间
            },
            consultDate:[],
            dropUserAll: [],
            props: { multiple: false, expandTrigger: 'hover' },
        }
    },
    watch:{
        Finalpaymenttime(newval,oldval){
            if(newval==null){
                this.param.StartTime=''
                this.param.EndTime=''
            }else{
                this.param.StartTime=newval[0]
                this.param.EndTime=newval[1]
            }
        },
        consultDate(newval,oldval){
            if(newval==null){
                this.diaParam.StartDate=''
                this.diaParam.EndDate=''
            }else{
                this.diaParam.StartDate=newval[0]
                this.diaParam.EndDate=newval[1]
            }
        },
    },
    mounted() {
        this.init();
        this.dropGetUserAll();
    },
    methods:{
        init(){
            this.loading=true;
            this.$Http_Post('/GroupClients/PostGroupClientsList',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0 || res.Code==200){
                    this.param.PageTotal=res.Counts;
                    this.GroupdemandsData=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        reset(){
            this.param=this.$options.data().param;
            this.init();
        },
        handleinitialization(val){
            this.param.pageNum=val;
            this.init();
        },
        handleClose(){
            this.dialogVisible=false;
            this.paramfollow=this.$options.data().paramfollow;
            this.$refs.uploadimgrefss.clearFiles();
            this.$refs.uploadfilerefss.clearFiles();
            this.programmePath=[];
            this.activePicture=[];
        },

        // 关闭新建团体诉求
        NewhandleClose(){
            this.NewdialogVisible=false;
        },
        dropGetUserAll() {
            this.$Http_Post('ConsultSubscribe/GetUserAll', {}).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                    this.dropUserAll = res.Data;
                }
            });
        },
        getCheckedNodes(val){
            if(val){
                this.diaParam.Counselor=val[1]
            }
        },

        ClickDetial(val){
            this.dialogVisible=true;
            this.paramfollow.serviceDemands=val.serviceDemands;
            this.paramfollow.activeContent=val.activeContent;
            this.paramfollow.requestKey=val.requestKey;
            this.paramfollow.userID=val.userID;
        },

        // 图片上传
        handleimgSuccess(file,filedata){
            this.activePicture.push(file.Data);
        },
        // 文件上传
        handlefileSuccess(file,filedata){
            this.programmePath.push(file.Data);
        },
        // 删除文件
        handlefileRemove(file){
            let index=this.programmePath.indexOf(file.response.Data);
            this.programmePath.splice(index,1);
        },

        // 删除图片
        handleRemove(file) {
            let index=this.activePicture.indexOf(file.response.Data);
            this.activePicture.splice(index,1);
        },
        save(){
            this.paramfollow.activePicture=this.activePicture.toString();
            this.paramfollow.programmePath=this.programmePath.toString();
            this.$Http_Post('/GroupClients/PostUpdateGroupClients',this.paramfollow).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.dialogVisible=false;
                    this.$refs.uploadimgrefss.clearFiles();
                    this.$refs.uploadfilerefss.clearFiles();
                    this.programmePath=[];
                    this.activePicture=[];
                    this.reset();
                    this.$message({ type: 'success', message: res.Message });
                }else{
                    this.$message({ type: 'error', message: res.Message});
                }
            })
        },

        ClickEdit(val){
            this.consultDate=[val.startDate,val.endDate];
            this.diaParam={
                userID:this.userID,
                RequestKey:val.requestKey,
                ConsultTheme:val.consultTheme,
                PeopleNum:val.peopleNum,
                ServicePrice:val.servicePrice,
                Discount:val.discount,
                StartDate:val.startDate,
                EndDate:val.endDate,
                Counselor:val.counselor,// 咨询师
                ConsultationLocation:val.consultationLocation,// 咨询地点
                CustomerServicePhone:val.customerServicePhone,//  客服电话
                StartTime:val.startTime,// 开始时间
                EndTime:val.endTime, //结束时间
            };
            this.NewdialogVisible=true;
        },

        // 新建团体诉求
        AddSave(){
            let url=this.diaParam.RequestKey==''?'/GroupClients/PostAddGroupClients':'/GroupClients/PostUpdateGroupClients';
            this.diaParam.userID=this.userID;
            this.$Http_Post(url,this.diaParam).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.diaParam=this.$options.data().diaParam;
                    this.consultTime=[];
                    this.consultDate=[];
                    this.init();
                    this.NewdialogVisible=false;
                    this.$message.success(res.Message);
                }else{
                    this.$message.error(res.Message);
                }
            })
        }

    },
}
</script>
<style scoped>
.Teamarchives .header{background: #fff;padding:20px;}
.Teamarchives .headerlabel{width:90px;display: inline-block;}
.Teamarchives .autowidth{width: 240px;}
.Teamarchives .MainContent{background: #fff;padding:20px 16px;margin:16px 0;}
.Teamarchives .ruleContent {margin: 0 20px;}
.Teamarchives .ruleContent .item{padding-top: 15px;display: flex;align-items: center;}
.Teamarchives .ruleContent .item label{margin-right: 15px;width: 70px;display: inline-block;}
.Teamarchives .uploadimg{display: inline-block;}
.Teamarchives .upload-demo{display: inline-block;}
.Teamarchives .courseTime{width: 120px;display: inline-block;}
</style>